module.exports = __webpack_public_path__ + "static/media/ProfileActiveIcon.0d85f6f5.png";